import { render, staticRenderFns } from "./Kermel.vue?vue&type=template&id=46e51a5a&scoped=true"
import script from "./Kermel.vue?vue&type=script&lang=js"
export * from "./Kermel.vue?vue&type=script&lang=js"
import style0 from "./Kermel.vue?vue&type=style&index=0&id=46e51a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e51a5a",
  null
  
)

export default component.exports